if (!customElements.get('lamena-product')) {
  class LamenaProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-variant-input]').disabled = false;
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-value-id]')) this.updateOptions(event.target);
      });
      this.addEventListener('click', (event) => this.handleClick(event));
      this.addEventListener('keydown', (event) => {
        if (!event.target.matches('[data-detail-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.querySelectorAll('[data-detail-tab]')];
        const current = tabs.indexOf(event.target);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.selectDetailTab(tabs[next].dataset.detailTab);
        tabs[next].focus();
      });
      this.addEventListener('submit', (event) => {
        if (this.getAttribute('aria-busy') === 'true' || !this.dataset.variantId) {
          event.preventDefault();
          return;
        }
        if (event.submitter && event.submitter.name !== 'add') return;
        if (!document.getElementById('CartDrawer') || window.theme?.settings?.cartType !== 'drawer') return;
        event.preventDefault();
        this.addToDrawer(event.target);
      });
      this.restoreFamilySelection();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    async addToDrawer(form) {
      if (this.adding) return;
      this.adding = true;
      const button = form.querySelector('[name="add"]');
      const status = this.querySelector('[data-product-status]');
      const controls = [...this.querySelectorAll('[data-option-value-id]')].map(input => ({input, disabled: input.disabled}));
      const data = new FormData(form);
      this.setAttribute('aria-busy', 'true');
      button.disabled = true;
      controls.forEach(({input}) => { input.disabled = true; });
      status.textContent = '';
      try {
        const response = await fetch(window.theme.routes.cartAdd, {method: 'POST', body: data, headers: {'Accept': 'application/json'}});
        const product = await response.json();
        if (!response.ok) { status.textContent = product.description || product.message || this.dataset.error; return; }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: {product, addToCartBtn: button}}));
      } catch (error) {
        status.textContent = this.dataset.error;
      } finally {
        this.adding = false;
        this.removeAttribute('aria-busy');
        button.disabled = false;
        controls.forEach(({input, disabled}) => { input.disabled = disabled; });
      }
    }
    async updateOptions(trigger) {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const url = new URL(this.dataset.url, window.location.origin);
      const ids = [...this.querySelectorAll('[data-option-value-id]:checked')].map((input) => input.dataset.optionValueId);
      url.searchParams.set('option_values', ids.join(','));
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[name="add"]').disabled = true;
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('section');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('lamena-product');
        if (!next) throw new Error('section');
        next.querySelectorAll('noscript').forEach((node) => node.remove());
        const position = trigger?.closest('[data-option-position]')?.dataset.optionPosition;
        const value = trigger?.value;
        const galleryScroll = this.querySelector('.lamena-pdp__gallery')?.scrollLeft || 0;
        this.replaceWith(next);
        next.querySelector('.lamena-pdp__gallery').scrollLeft = galleryScroll;
        if (position) {
          const field = [...next.querySelectorAll('[data-option-position]')].find((item) => item.dataset.optionPosition === position);
          [...(field?.querySelectorAll('input') || [])].find((input) => input.value === value)?.focus({preventScroll: true});
        }
        const historyUrl = new URL(window.location.href);
        historyUrl.searchParams.delete('option_values');
        historyUrl.searchParams.delete('variant');
        if (next.dataset.variantId) historyUrl.searchParams.set('variant', next.dataset.variantId);
        else historyUrl.searchParams.set('option_values', ids.join(','));
        window.history.replaceState({}, '', historyUrl);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.removeAttribute('aria-busy');
        this.dataset.variantId = '';
        this.querySelector('[data-variant-input]').value = '';
        this.querySelector('[data-product-status]').textContent = this.dataset.error;
      }
    }
    handleClick(event) {
      const detail = event.target.closest('[data-details-trigger]');
      if (detail) {
        this.selectDetailTab(detail.dataset.detailsTrigger);
        this.querySelector('[data-details-dialog]').showModal();
      }
      const tab = event.target.closest('[data-detail-tab]');
      if (tab) this.selectDetailTab(tab.dataset.detailTab);
      const fit = event.target.closest('[data-fit-toggle]');
      if (fit) {
        const isOpen = fit.getAttribute('aria-expanded') === 'true';
        fit.setAttribute('aria-expanded', String(!isOpen));
        fit.querySelector('.lamena-pdp__fit-tooltip').hidden = isOpen;
      }
      if (event.target.closest('[data-close-length]')) this.querySelector('[data-length-note]').hidden = true;
      const measureUnit = event.target.closest('[data-measure-unit]');
      if (measureUnit) {
        const unit = measureUnit.dataset.measureUnit;
        for (const button of this.querySelectorAll('[data-measure-unit]')) button.setAttribute('aria-pressed', String(button === measureUnit));
        for (const measure of this.querySelectorAll('[data-measure-cm]')) {
          const value = Number(measure.dataset.measureCm);
          measure.textContent = unit === 'in' ? `${Math.round(value / 2.54 * 10) / 10} in` : `${value} cm`;
        }
      }
      const railButton = event.target.closest('[data-look-scroll]');
      if (railButton) {
        const rail = this.querySelector('[data-look-rail]');
        rail.scrollBy({left: Number(railButton.dataset.lookScroll) * rail.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      if (event.target.closest('[data-open-look]')) {
        const target = this.querySelector('[data-look-dialog-body]');
        target.replaceChildren(this.querySelector('[data-look-rail]').cloneNode(true));
        this.querySelector('[data-look-dialog]').showModal();
      }
      const familyLink = event.target.closest('[data-family-link]');
      if (familyLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        try {
          const selections = [...this.querySelectorAll('[data-option-name]')].map((field) => ({name: field.dataset.optionName.toLowerCase(), value: field.querySelector('input:checked')?.value}));
          sessionStorage.setItem('lamena-colour-selection', JSON.stringify({path: new URL(familyLink.href).pathname, selections}));
        } catch {}
      }
      const guide = event.target.closest('[data-open-guide]');
      if (guide) this.querySelector('[data-size-dialog]')?.showModal();
      const imageLink = event.target.closest('[data-zoom-image]');
      if (imageLink) {
        event.preventDefault();
        const dialog = this.querySelector('[data-zoom-dialog]');
        const image = dialog.querySelector('img');
        image.src = imageLink.href;
        image.alt = imageLink.querySelector('img').alt;
        dialog.showModal();
      }
      const closer = event.target.closest('[data-close-dialog]');
      if (closer) closer.closest('dialog').close();
      if (event.target.tagName === 'DIALOG') {
        const bounds = event.target.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
      }
    }
    selectDetailTab(name) {
      for (const tab of this.querySelectorAll('[data-detail-tab]')) {
        const selected = tab.dataset.detailTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      }
      for (const panel of this.querySelectorAll('[data-detail-panel]')) panel.hidden = panel.dataset.detailPanel !== name;
    }
    restoreFamilySelection() {
      let saved;
      try {
        saved = JSON.parse(sessionStorage.getItem('lamena-colour-selection') || 'null');
        if (!saved || saved.path !== window.location.pathname) return;
        sessionStorage.removeItem('lamena-colour-selection');
      } catch {return;}
      let changed = false;
      let missing = false;
      for (const field of this.querySelectorAll('[data-option-name]')) {
        const previous = saved.selections.find((item) => item.name === field.dataset.optionName.toLowerCase());
        if (!previous) continue;
        const match = [...field.querySelectorAll('input')].find((input) => input.value === previous.value);
        if (match) {
          changed ||= !match.checked;
          match.checked = true;
        } else missing = true;
      }
      if (missing) {
        this.dataset.variantId = '';
        this.querySelector('[data-variant-input]').value = '';
        this.querySelector('[name="add"]').disabled = true;
        this.querySelector('[data-product-status]').textContent = this.dataset.error;
      } else if (changed) this.updateOptions();
    }
  }
  customElements.define('lamena-product', LamenaProduct);
}
